export const PRODUCTS_LIST_CONTROLLER = "PRODUCTS_LIST_CONTROLLER";
export const PORTFOLIO_LIST_CONTROLLER = "PORTFOLIO_LIST_CONTROLLER";
export const BLOGS_LIST_CONTROLLER = "BLOGS_LIST_CONTROLLER";
export const EVENTS_LIST_CONTROLLER = "EVENTS_LIST_CONTROLLER";